module.exports = __webpack_public_path__ + "img/1.2ea0dca7.png";